import { getConsent, onConsentChange } from '@/privacy/consent';
import { useEffect } from 'react';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const updateConsentSignals = () => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  const consent = getConsent();
  const analyticsGranted = Boolean(consent?.categories.analytics);
  const marketingGranted = Boolean(consent?.categories.marketing);

  window.gtag('consent', 'update', {
    analytics_storage: analyticsGranted ? 'granted' : 'denied',
    functionality_storage: analyticsGranted ? 'granted' : 'denied',
    ad_user_data: marketingGranted ? 'granted' : 'denied',
    ad_personalization: marketingGranted ? 'granted' : 'denied',
    ad_storage: marketingGranted ? 'granted' : 'denied',
  });
};

const useAnalytics = () => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const unsubscribe = onConsentChange(() => {
      updateConsentSignals();
    });

    return () => {
      unsubscribe();
    };
  }, []);
};

export default useAnalytics;
